function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".linkedin_icon_svg__cls-1{fill:#ddd33d}"));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "linkedin_icon_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "linkedin_icon_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "linkedin_icon_svg__cls-1",
  d: "M3.76 7.22A3.62 3.62 0 1 0 3.81 0 3.52 3.52 0 0 0 0 3.63a3.53 3.53 0 0 0 3.76 3.59zM.19 9.59h7.24v20.47H.19zM10.55 9.72h7.05v2.79a7.07 7.07 0 0 1 6.26-3.25C28.4 9.26 31.8 12 31.8 18v12.06h-6.9V18.79c0-2.62-1-4.41-3.5-4.41a3.65 3.65 0 0 0-3.49 2.37 4.06 4.06 0 0 0-.28 1.58v11.73h-7.08s.09-18.55 0-20.34z"
})));

var SvgLinkedinIcon = function SvgLinkedinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31.8 30.06"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMS44IDMwLjA2Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2RkZDMzZDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFzc2V0IDM8L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMy43Niw3LjIyQTMuNjIsMy42MiwwLDEsMCwzLjgxLDAsMy41MiwzLjUyLDAsMCwwLDAsMy42MywzLjUzLDMuNTMsMCwwLDAsMy43Niw3LjIyWiIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMC4xOSIgeT0iOS41OSIgd2lkdGg9IjcuMjQiIGhlaWdodD0iMjAuNDciLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMC41NSw5LjcySDE3LjZ2Mi43OWE3LjA3LDcuMDcsMCwwLDEsNi4yNi0zLjI1QzI4LjQsOS4yNiwzMS44LDEyLDMxLjgsMThWMzAuMDZIMjQuOVYxOC43OWMwLTIuNjItMS00LjQxLTMuNS00LjQxYTMuNjUsMy42NSwwLDAsMC0zLjQ5LDIuMzcsNC4wNiw0LjA2LDAsMCwwLS4yOCwxLjU4VjMwLjA2SDEwLjU1UzEwLjY0LDExLjUxLDEwLjU1LDkuNzJaIi8+PC9nPjwvZz48L3N2Zz4=";
export { SvgLinkedinIcon as ReactComponent };